import { render, staticRenderFns } from "./detailSZ.vue?vue&type=template&id=53dac6b9&scoped=true"
import script from "./detailSZ.vue?vue&type=script&lang=js"
export * from "./detailSZ.vue?vue&type=script&lang=js"
import style0 from "./detailSZ.vue?vue&type=style&index=0&id=53dac6b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dac6b9",
  null
  
)

export default component.exports